<template>

    <!--<vs-avatar
      v-if="params.data"
      :src="params.data.avatar"
      class="flex-shrink-0 mr-2"
      size="30px"
      @click="$router.push(url)"
    />-->
    <router-link
      :to="url"
      @click.stop.prevent
      class="text-inherit hover:text-primary"
    ><div class="flex items-center">{{ params.value }}</div></router-link>

</template>

<script>
export default {
  name: 'CellRendererLink',
  computed: {
    url () {
      return `/admin/users/bride/view/${this.params.data ? this.params.data.id : 0}`
    }
  }
}
</script>
